// extracted by mini-css-extract-plugin
module.exports = {"title":"Text_title__3S9Nt","heading":"Text_heading__1rWi3","subtitle":"Text_subtitle__35z_b","link":"Text_link__2zuC3","disabled":"Text_disabled__1hgja","body":"Text_body__zPkRF"};